var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9062 3.375H3.09375C2.3171 3.375 1.6875 4.0046 1.6875 4.78125V13.2188C1.6875 13.9954 2.3171 14.625 3.09375 14.625H14.9062C15.6829 14.625 16.3125 13.9954 16.3125 13.2188V4.78125C16.3125 4.0046 15.6829 3.375 14.9062 3.375Z",
    stroke: "#FFDB70",
    strokeWidth: 1.23047,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9375 5.625L9 9.5625L14.0625 5.625",
    stroke: "#FFDB70",
    strokeWidth: 1.23047,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.7423005887505a34810158bc7c718f57.svg";
export { ForwardRef as ReactComponent };